import { render, staticRenderFns } from "./ShippingAddress.vue?vue&type=template&id=5900dfbb&scoped=true"
import script from "./ShippingAddress.vue?vue&type=script&lang=js"
export * from "./ShippingAddress.vue?vue&type=script&lang=js"
import style0 from "./ShippingAddress.vue?vue&type=style&index=0&id=5900dfbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5900dfbb",
  null
  
)

export default component.exports